export default __webpack_public_path__ + "static/media/10630 - BoJangle.c88e0aa1.jpeg";